<div class="modal fade ig-search-modal" id="modalBusqueda" tabindex="-1" aria-labelledby="tituloModalBusqueda" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header ig-modal-header">
        <div class="header-title-group">
          <div class="search-icon"><i class="fa-solid fa-paw" aria-hidden="true"></i></div>
          <div>
            <span class="eyebrow">DESCUBRE LA COMUNIDAD</span>
            <h2 class="modal-title" id="tituloModalBusqueda">Encuentra nuevas amistades</h2>
            <p>Busca mascotas por nombre, tipo, sexo o tamaño.</p>
          </div>
        </div>
        <button type="button" class="btn-close ig-close" data-bs-dismiss="modal" aria-label="Cerrar búsqueda"></button>
      </div>

      <div class="modal-body ig-modal-body">
        <form (ngSubmit)="buscar()" autocomplete="off">
          <div class="filters-grid">
            <div class="field name-field">
              <label for="inputBusqueda"><i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i> Nombre de la mascota</label>
              <div class="input-with-icon">
                <i class="fa-solid fa-paw" aria-hidden="true"></i>
                <input type="search" class="form-control" id="inputBusqueda" #inputBusqueda name="nombre" placeholder="¿A quién quieres conocer?" [(ngModel)]="busqueda.nombre" maxlength="100">
              </div>
            </div>

            <div class="field">
              <label for="inputTipo"><i class="fa-solid fa-list" aria-hidden="true"></i> Tipo de mascota</label>
              <app-iguau-select
                id="inputTipo"
                name="tipo"
                [items]="tipos_mascotas"
                bindLabel="label"
                bindValue="value"
                groupBy="mt_categoria"
                placeholder="Todos los tipos"
                searchPlaceholder="Buscar tipo de mascota..."
                notFoundText="Tipo no encontrado"
                [(ngModel)]="busqueda.tipo">
              </app-iguau-select>
            </div>

            <div class="field">
              <label for="inputSexo"><i class="fa-solid fa-venus-mars" aria-hidden="true"></i> Sexo</label>
              <select id="inputSexo" name="sexo" class="form-select" [(ngModel)]="busqueda.sexo">
                <option value="">Cualquiera</option>
                <option value="Macho">Macho</option>
                <option value="Hembra">Hembra</option>
                <option value="Desconocido">Desconocido</option>
                <option value="No aplica">No aplica</option>
              </select>
            </div>

            <div class="field">
              <label for="inputTamano"><i class="fa-solid fa-ruler-combined" aria-hidden="true"></i> Tamaño</label>
              <select id="inputTamano" name="tamano" class="form-select" [(ngModel)]="busqueda.tamano">
                <option value="">Todos los tamaños</option>
                <option value="Pequeño">Pequeño</option>
                <option value="Mediano">Mediano</option>
                <option value="Grande">Grande</option>
              </select>
            </div>
          </div>

          <div class="search-tip"><i class="fa-regular fa-lightbulb" aria-hidden="true"></i> Puedes combinar los filtros para encontrar mascotas que se ajusten a tu búsqueda.</div>

          <div class="modal-actions">
            <button type="button" class="btn clear-btn" (click)="limpiar()" [disabled]="!hayFiltros"><i class="fa-solid fa-rotate-left" aria-hidden="true"></i> Limpiar filtros</button>
            <button type="submit" class="btn search-btn" [disabled]="!hayFiltros"><i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i> Buscar mascotas <i class="fa-solid fa-arrow-right" aria-hidden="true"></i></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
